import client from '../../api/client';
import type { BrandConfig } from '../../api/brand';

export type ChecklistStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';

export type ChecklistApplication = {
  id: number;
  application_uid: string | null;
  company_name: string | null;
  onboarding_form_status: ChecklistStatus | null;
  onboarding_form_completed_at: string | null;
  merchant_conditions_status: ChecklistStatus | null;
  merchant_conditions_accepted_at: string | null;
  rapyd_agreement_status: ChecklistStatus | null;
  rapyd_agreement_signed_at: string | null;
  zoho_sign_url: string | null;
  gocardless_dd_status: ChecklistStatus | null;
  gocardless_dd_completed_at: string | null;
  gocardless_flow_url: string | null;
};

export async function fetchMyApplication() {
  const res = await client.get('/applications/me');
  return (res.data?.application || null) as ChecklistApplication | null;
}

export async function fetchChecklist(applicationId: number) {
  const res = await client.get(`/applications/${applicationId}/checklist`);
  return res.data?.application as ChecklistApplication;
}

export async function acceptMerchantConditions(applicationId: number) {
  const res = await client.post(`/applications/${applicationId}/merchant-conditions/accept`);
  return res.data?.application as ChecklistApplication;
}

export async function startRapydAgreement(applicationId: number, brand: BrandConfig | null) {
  const res = await client.post(`/applications/${applicationId}/rapyd-agreement`, {
    register_authorize_requirements: brand?.register_authorize_requirements,
  });
  return { application: res.data?.application as ChecklistApplication, signUrl: res.data?.sign_url as string };
}

export async function startDirectDebit(applicationId: number, brand: BrandConfig | null) {
  const res = await client.post(`/applications/${applicationId}/direct-debit`, {
    register_authorize_requirements: brand?.register_authorize_requirements,
    return_origin: typeof window !== 'undefined' ? window.location.origin : '',
  });
  return { application: res.data?.application as ChecklistApplication, flowUrl: res.data?.flow_url as string };
}

export function brandShowsAgreement(brand: BrandConfig | null) {
  return brand?.register_authorize_requirements?.signedContract?.enabled !== false;
}

export function brandShowsDirectDebit(brand: BrandConfig | null) {
  return brand?.register_authorize_requirements?.authorizedDirectDebit?.enabled !== false;
}
